export const OfflineConstants = {
    versionNumber: 1, // Remember to increment this number when adding/removing/changing the stores
    stores: {
        aol: {
            storeName: 'aolStore',
        },
        reportEvents: {
            storeName: 'reportEventsStore',
        },
        bunkering: {
            storeName: 'bunkeringStore',
        },
        settings: {
            storeName: 'settingsStore',
            excludeFromSync: true,
        },
        stowage: {
            storeName: 'stowageStore',
        },
        cargoTempLog: {
            storeName: 'cargoTempLogStore',
        },
    },
};
